import React, { useEffect, useState, useCallback, useRef } from "react";
import Order from "./Order";
import AssignModal from "./AssignModal";
import DetailsModal from "./DetailsModal";
import OrderLabel from "./OrderLabel";
import "../Css/Current.css";
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField, Typography, CircularProgress, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, InputLabel, Select, Modal, TextareaAutosize, } from "@mui/material";
import Logger from "./Logger";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import { MdDelete } from "react-icons/md";
import { Tooltip } from "react-tooltip";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { MdDoNotDisturb } from "react-icons/md";
import PaginationControls from "../Component/Pagination";
import { FaListUl } from "react-icons/fa";
import { connectSocket } from "../utils/connectSocket";
import { getLoggerBaseURL } from "../utils/getLoggerBaseURL";

const ReasonModal = ({ open, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason(""); // Reset reason
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "16px",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "400px",
          margin: "100px auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h2 sx={{ textAlign: "center" }} className="text-xl font-semibold mb-4">
          Enter Reason
        </h2>
        <TextareaAutosize
          minRows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter reason..."
          className="w-full border p-2 rounded"
        />
        <div
          className="flex justify-end mt-4"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "16px",
          }}
        >
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{ marginRight: "8px" }}
          >
            Cancel
          </Button>
          <Button onClick={() => onSubmit(reason)} disabled={!reason.trim()}>
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
};

function Current() {
  const [orders, setOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDModal, setShowDModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("OrderNo");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [selectedOrdersForLabel, setSelectedOrdersForLabel] = useState([]); // State for showing the label modal
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedOrderIds, setSelectedOrderIds] = useState([]); //for bulk deletion
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showUnassignModal, setShowUnassignModal] = useState(false);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [selectedOrders, setSelectedOrders] = React.useState([]);
  const [loading, setLoading] = useState(true);
  const userEmail = sessionStorage.getItem("userEmail");
  const [inputMop, setInputMop] = useState("");
  const [inputMop2, setInputMop2] = useState("");
  const [inputMop3, setInputMop3] = useState("");
  const [enteredAmount1, setEnteredAmount1] = useState("");
  const [enteredAmount2, setEnteredAmount2] = useState("");
  const [enteredAmount3, setEnteredAmount3] = useState("");
  const [inputDelDate, setInputdelDate] = useState("");
  const [error, setError] = useState("");
  const [paymentType, setPaymentType] = useState("full");
  const [isFormValid, setIsFormValid] = useState(false);
  const [receiver, setReceiver] = useState("");
  const [phone, setPhone] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editOrderDetails, setEditOrderDetails] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const currentPageRef = useRef(1);
  const itemsPerPage = 50;
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState("");
  const [statusToDisableReassignButton, setStatusToDisableReassignButton] = useState("");
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [reason, setReason] = useState("");
  const [orderAmount, setOrderAmount] = useState(0); // Store order amount
  const [warning, setWarning] = useState("");
  const [userName, setUserName] = useState("");
  const [chequeNumber1, setChequeNumber1] = useState("");
  const [chequeNumber2, setChequeNumber2] = useState("");
  const [chequeNumber3, setChequeNumber3] = useState("");
  const [chequeDate1, setChequeDate1] = useState("");
  const [chequeDate2, setChequeDate2] = useState("");
  const [chequeDate3, setChequeDate3] = useState("");
  const [bankName1, setBankName1] = useState("");
  const [bankName2, setBankName2] = useState("");
  const [bankName3, setBankName3] = useState("");
  const [chequeDateError1, setChequeDateError1] = useState("");
  const [chequeDateError2, setChequeDateError2] = useState("");
  const [chequeDateError3, setChequeDateError3] = useState("");
  const [openBillModal, setOpenBillModal] = useState(true);
  const [billOrders, setBillOrders] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);

  // Initialize Logger
  const logger = new Logger(getLoggerBaseURL());

  const role = sessionStorage.getItem("role");
  let permission = {};
  const permissionString = sessionStorage.getItem("permissions");
  if (permissionString) {
    permission = JSON.parse(permissionString);
  } else {
    logger.log("Permission missing", "ERROR");
  }

  useEffect(() => {
    const socket = connectSocket();
    socket.on("orderStatus", (order) => {
      setOrders((prevOrders) => {
        const updatedOrders = prevOrders.map((o) => {
          if (o._id === order._id) {
            return {
              ...order,
              driverName: order.driverName || o.driverName, // Retain old driverName if not present in the new order
            };
          }
          return o;
        });
        return updatedOrders;
      });
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);

  useEffect(() => {
    if ((startDate && !endDate) || (!startDate && endDate)) return;
    fetchOrders(1);
  }, [searchQuery, selectedOption, startDate, endDate]);

  useEffect(() => {
    const onOrdersUpdated = () => fetchOrders(currentPageRef.current);
    window.addEventListener("zordigo-orders-updated", onOrdersUpdated);
    return () => window.removeEventListener("zordigo-orders-updated", onOrdersUpdated);
  }, []);

  useEffect(() => {
    const validateForm = () => {
      if (paymentType === "full") {
        setIsFormValid(
          inputMop !== "" &&
          enteredAmount1 !== "" &&
          inputDelDate !== "" &&
          receiver !== ""
        );
      } else if (paymentType === "twoParts") {
        setIsFormValid(
          inputMop !== "" &&
          enteredAmount1 !== "" &&
          inputMop2 !== "" &&
          enteredAmount2 !== "" &&
          inputDelDate !== "" &&
          receiver !== ""
        );
      } else if (paymentType === "threeParts") {
        setIsFormValid(
          inputMop !== "" &&
          enteredAmount1 !== "" &&
          enteredAmount2 !== "" &&
          inputMop3 !== "" &&
          enteredAmount3 !== "" &&
          inputDelDate !== "" &&
          receiver !== ""
        );
      } else {
        setIsFormValid(false);
      }
    };
    validateForm();
  }, [
    paymentType,
    inputMop,
    enteredAmount1,
    inputMop2,
    enteredAmount2,
    inputMop3,
    enteredAmount3,
    receiver,
  ]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`/api/getUsersEmail/${userEmail}`);
        if (response.ok) {
          const userData = await response.json();
          setUserName(userData.user.name);
        } else {
          logger.log("Failed to fetch user data for Navbar", "ERROR");
        }
      } catch (error) {
        logger.log(`Error fetching user data: ${error.message}`, "ERROR");
      }
    };

    if (userEmail) {
      fetchUserData();
    }
  }, [userEmail]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSuccessSnackbarOpen(false);
  };

  const handleViewDetailsDropdownClick = (orderId) => {
    const selectedOrder = orders.find((order) => order._id === orderId);
    setSelectedOrder(selectedOrder);
    setShowDModal(true); // Open the details modal
  };

  const handleOrderDetailsClick = (orderId) => {
    const selectedOrder = orders.find((order) => order._id === orderId);
    setSelectedOrder(selectedOrder);
    setShowDModal(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleReassignClick = (orderId) => {
    setSelectedOrderId(orderId);
    setActionType("Reassign");
    setShowReasonModal(true);
    setReason(reason);
  };

  const handleThreeDotsClick = (event, orderId, finalStatus) => {
    if (anchorEl === event.currentTarget) {
      // If the same anchorEl is clicked again, close the dropdown
      setAnchorEl(null);
    } else {
      // Otherwise, set the anchorEl to the clicked element
      setAnchorEl(event.currentTarget);
      setSelectedOrderId(orderId); // Set the selected order ID
      setStatusToDisableReassignButton(finalStatus);
    }
  };

  const handleCancelOrder = async () => {
    try {
      const response = await fetch(`/api/ordera/delete/${userEmail}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderIds: selectedOrderIds }),
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message);
      }

      const deletedCount = selectedOrderIds.length;
      setSelectedOrderIds([]);
      setSelectedOrders([]);
      setShowCancelModal(false);

      const nextTotal = Math.max(0, (Number(totalOrders) || 0) - deletedCount);
      const maxPage = Math.max(1, Math.ceil(nextTotal / itemsPerPage) || 1);
      const pageToLoad = Math.min(currentPageRef.current, maxPage);
      currentPageRef.current = pageToLoad;
      await fetchOrders(pageToLoad);
      // KPI badge only — Current already refetched this page
      window.dispatchEvent(new CustomEvent("zordigo-orders-updated"));
    } catch (error) {
      logger.log(`Error cancelling orders: ${error.message}`, "ERROR");
    }
  };

  const handleUnassignOrder = () => {
    setSelectedOrderId(selectedOrderId);
    setActionType("Unassign");
    setReason("");
    setShowReasonModal(true);
  };

  const handleOpenCancelModal = (orderIds) => {
    if (!Array.isArray(orderIds)) {
      // If orderIds is not already an array, wrap it in an array
      orderIds = [orderIds];
    }
    setSelectedOrderIds(orderIds); // Store the array of selected order IDs
    setShowCancelModal(true); // Open the modal
  };

  const handleOpenReassignModal = (orderIds) => {
    if (!Array.isArray(orderIds)) {
      // If orderIds is not already an array, wrap it in an array
      orderIds = [orderIds];
    }
    setSelectedOrderIds(orderIds); // Store the array of selected order IDs
    setReason("");
    setShowUnassignModal(true); // Open the modal
  };

  const handleOpenCompleteModal = (orderId) => {
    setSelectedOrderId(orderId);
    const selectedOrder = orders.find((order) => order._id === orderId); // Adjust as per your data structure
    if (selectedOrder) {
      setOrderAmount(selectedOrder.amount); // Set order amount
      setEnteredAmount1(selectedOrder.amount); // Auto-fill for full payment
    }
    setShowCompleteModal(true);
  };

  const handleCloseCancelModal = () => {
    setShowCancelModal(false);
  };

  const handleCloseUnassignModal = () => {
    setReason("");
    setShowUnassignModal(false);
  };

  const handleClosecompleteModal = () => {
    setShowCompleteModal(false);
    setPaymentType("full");
    setInputMop("");
    setEnteredAmount1("");
    setInputMop2("");
    setEnteredAmount2("");
    setInputMop3("");
    setEnteredAmount3("");
    setInputdelDate("");
    setReceiver("");
    setPhone("");
  };

  const handlephonechange = (e) => {
    const value = e.target.value;
    if (value.length > 10) {
      // Prevent entering more than 10 digits
      setError("PhoneNumber should not exceed 10 digits");
    } else if (value.length < 10) {
      // Update the phone value and clear error if length is less than 10
      setPhone(value);
      setError("PhoneNumber should be exactly 10 digits");
    } else {
      // When the phone number is exactly 10 digits
      setPhone(value);
      setError("");
    }
  };

  const fetchOrders = async (page = 1) => {
    const requestedPage = Math.max(1, Number(page) || 1);
    try {
      setLoading(true);

      const params = new URLSearchParams({
        page: String(requestedPage),
        limit: String(itemsPerPage),
        status: "current",
        selectedOption: selectedOption || "",
        keyword: searchQuery || "",
      });
      if (startDate && endDate) {
        params.set("startDate", startDate);
        params.set("endDate", endDate);
      }

      const res = await fetch(`/api/ordera/${userEmail}?${params.toString()}`);
      const json = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(json.message || `Failed to load orders (${res.status})`);
      }

      const total = Number(json.total) || 0;
      const maxPage = Math.max(
        1,
        Number(json.maxPage) || Math.ceil(total / itemsPerPage) || 1,
      );
      let nextPage = Number(json.page) || requestedPage;

      // Stale last-page click / out of range — load the real last page once
      if (json.outOfRange || (total > 0 && requestedPage > maxPage)) {
        setTotalOrders(total);
        setCurrentPage(maxPage);
        currentPageRef.current = maxPage;
        if (maxPage !== requestedPage) {
          return await fetchOrders(maxPage);
        }
      }

      setOrders(Array.isArray(json.data) ? json.data : []);
      setTotalOrders(total);
      nextPage = Math.min(Math.max(1, nextPage), maxPage);
      setCurrentPage(nextPage);
      currentPageRef.current = nextPage;

      if (
        total > 0 &&
        (!json.data || json.data.length === 0) &&
        nextPage > 1 &&
        requestedPage === nextPage
      ) {
        // Empty page but not page 1 — step back instead of showing a blank crash state
        return await fetchOrders(nextPage - 1);
      }
    } catch (error) {
      logger.log(`Error fetching orders for email ${userEmail}: ${error.message}`, "ERROR");
      toast.error(
        error.message?.includes("timed out")
          ? "Loading that page took too long. Try a nearby page or refresh."
          : `Could not load orders: ${error.message}`,
        { autoClose: 5000 },
      );
      // Keep previous rows — do not wipe the table into an empty "crash" state
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (orderId, newValue) => {
    // Update the pickup_ready field in the order object with the new value
    const updatedOrders = orders.map((order) => {
      if (order._id === orderId) {
        return { ...order, pickup_ready: newValue };
      }
      return order;
    });
    setOrders(updatedOrders);

    fetch(`/api/ordera/pickup/${orderId}/${userEmail}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pickup_ready: newValue }),
    })
      .then((response) => response.json())
      .catch((error) =>
        logger.log(`Error updating pickup_ready: ${error.message}`, "ERROR")
      );
  };

  const handleStatusUpdated = useCallback(() => {
    // Fetch the updated orders data from the backend
    const fetchUpdatedOrders = async () => {
      try {
        const response = await fetch(`/api/ordera/${userEmail}`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        setOrders(Array.isArray(data.data) ? data.data : []);
        setTotalOrders(data.total || 0);
      } catch (error) {
        logger.log(`Error fetching updated data: ${error.message}`, "ERROR");
      }
    };
    fetchUpdatedOrders();
  }, []);

  const handleAssignClick = useCallback((orderId) => {
    setSelectedOrderId(orderId);
    setActionType("assign");
    setShowModal(true);
    setReason("");
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowReasonModal(false);
    setShowModal(false);
    setSelectedOrderId(null);
  }, []);

  const handleReasonSubmit = useCallback(
    (reason) => {
      setReason(reason);
      setShowReasonModal(false);

      if (actionType === "Reassign") {
        setShowModal(true);
        setReason("");
      } else if (actionType === "Unassign") {
        setReason("");
        unassignOrder(selectedOrderId, reason);
      }
    },
    [actionType, selectedOrderId]
  );

  const unassignOrder = async (orderId, reason) => {
    try {
      const response = await fetch(`/api/ordera/unassign/${userEmail}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderIds: [orderId], reason }),
      });

      if (response.ok) {
        setReason("");
        setShowUnassignModal(false);
        await handleStatusUpdated();
      } else {
        logger.log("Error unassigning order", "ERROR");
      }
    } catch (error) {
      logger.log(`Error unassigning order: ${error.message}`, "ERROR");
    }
  };

  const handleViewLabelClick = (orderId) => {
    // Ensure that selectedOrdersForLabel is cleared
    setSelectedOrdersForLabel([]);

    const selectedOrder = orders.find((order) => order._id === orderId);
    const selectedOrderWithEmail = {
      ...selectedOrder,
      adminEmail: userEmail,
    };
    setSelectedOrder(selectedOrderWithEmail);
    setShowLabelModal(true); // Open the label modal
  };

  const handleCompleteOrder = async (orderId) => {
    if (phone.length !== 10) {
      setSnackbarMessage("Phone number should be exactly 10 digits.");
      setSnackbarOpen(true);
      return;
    }

    if (paymentType === "full") {
      if (!inputMop || !enteredAmount1 || !inputDelDate) {
        setSnackbarMessage(
          "For full payment, Mode of Payment, Amount 1, and Date are required."
        );
        setSnackbarOpen(true);
        return;
      }
    } else if (paymentType === "twoParts") {
      if (
        !inputMop ||
        !enteredAmount1 ||
        !inputMop2 ||
        !enteredAmount2 ||
        !inputDelDate
      ) {
        setSnackbarMessage(
          "For two-part payment, Mode of Payment, Amount 1, Secondary Mode of Payment, and Amount 2 are required."
        );
        setSnackbarOpen(true);
        return;
      }
    } else if (paymentType === "threeParts") {
      if (
        !inputMop ||
        !enteredAmount1 ||
        !inputMop2 ||
        !enteredAmount2 ||
        !inputMop3 ||
        !enteredAmount3 ||
        !inputDelDate
      ) {
        setSnackbarMessage(
          "For three-part payment, Mode of Payment, Amount 1, Secondary Mode of Payment, Amount 2, Tertiary Mode of Payment, and Amount 3 are required."
        );
        setSnackbarOpen(true);
        return;
      }
    }

    // Validate cheque details if applicable
    let chequeDetails = {};

    const validateCheque = (
      chequeNumber,
      chequeAmount,
      chequeBank,
      chequeDate,
      label
    ) => {
      if (!chequeNumber || !chequeAmount || !chequeBank || !chequeDate) {
        setSnackbarMessage(
          `Please provide all cheque details for ${label} (Number, Amount, Bank, Date).`
        );
        setSnackbarOpen(true);
        return false;
      }

      // Checking if cheque number is numeric and has valid length (6 to 10 digits)
      const chequeNumberRegex = /^\d{6}$/;
      if (!chequeNumberRegex.test(chequeNumber)) {
        setSnackbarMessage(
          `Please enter a valid Cheque Number. The Cheque Number should be of 6 digits only.`
        );
        setSnackbarOpen(true);
        return false;
      }

      // Validate cheque date (Not older than 3 months)
      const selectedDate = new Date(chequeDate);
      const currentDate = new Date();
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(currentDate.getMonth() - 3);

      if (selectedDate < threeMonthsAgo) {
        setSnackbarMessage(
          `${label} cheque date cannot be older than 3 months.`
        );
        setSnackbarOpen(true);
        return false;
      }

      return true;
    };

    if (inputMop === "Cheque") {
      if (
        !validateCheque(
          chequeNumber1,
          enteredAmount1,
          bankName1,
          chequeDate1,
          "Primary MOP"
        )
      ) {
        return;
      }
      chequeDetails.cheque1 = {
        no: chequeNumber1,
        amount: enteredAmount1,
        date: chequeDate1,
        bank: bankName1,
      };
    }

    if (inputMop2 === "Cheque") {
      if (
        !validateCheque(
          chequeNumber2,
          enteredAmount2,
          bankName2,
          chequeDate2,
          "Secondary MOP"
        )
      ) {
        return;
      }
      chequeDetails.cheque2 = {
        no: chequeNumber2,
        amount: enteredAmount2,
        date: chequeDate2,
        bank: bankName2,
      };
    }

    if (inputMop3 === "Cheque") {
      if (
        !validateCheque(
          chequeNumber3,
          enteredAmount3,
          bankName3,
          chequeDate3,
          "Tertiary MOP"
        )
      ) {
        return;
      }
      chequeDetails.cheque3 = {
        no: chequeNumber3,
        amount: enteredAmount3,
        date: chequeDate3,
        bank: bankName3,
      };
    }

    try {
      // Prepare data to send to the backend
      const requestData = {
        mop: inputMop,
        mop2: inputMop2 || null,
        mop3: inputMop3 || null,
        amount1: enteredAmount1 || null,
        amount2: enteredAmount2 || null,
        amount3: enteredAmount3 || null,
        Del_Date_Actual: inputDelDate || null,
        Receiver: receiver || null,
        Phone: phone || null,
      };

      // Only add chequeDetails if it's not empty
      if (Object.keys(chequeDetails).length > 0) {
        requestData.chequeDetails = chequeDetails;
      }

      // Send data to the backend
      const response = await fetch(
        `/api/DrOrder/complete/${userEmail}/${selectedOrderId}/${userName}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        // Reset input fields
        setPaymentType("full");
        setInputMop("");
        setEnteredAmount1("");
        setInputMop2("");
        setEnteredAmount2("");
        setInputMop3("");
        setEnteredAmount3("");
        setInputdelDate("");
        setReceiver("");
        setPhone("");
        setChequeNumber1("");
        setChequeNumber2("");
        setChequeNumber3("");
        setChequeDate1("");
        setChequeDate2("");
        setChequeDate3("");
        setBankName1("");
        setBankName2("");
        setBankName3("");

        // Handle status update and show success message
        await handleStatusUpdated();
        toast.success("Order Completed Successfully");
        setShowCompleteModal(false);
      } else {
        const errorData = await response.json();
        logger.log(`Error completing order: ${errorData.message}`, "ERROR");

        if (errorData.message.includes("Amount1 should be a valid number")) {
          setSnackbarMessage("Please enter a valid number for Amount1.");
        } else if (
          errorData.message.includes("Amount2 should be a valid number")
        ) {
          setSnackbarMessage("Please enter a valid number for Amount2.");
        } else if (
          errorData.message.includes("PhoneNumber should be a valid number")
        ) {
          setSnackbarMessage("Please enter a valid phone number.");
        } else {
          setSnackbarMessage(
            "An error occurred while completing the order. Please try again."
          );
        }
        setSnackbarOpen(true);
      }
    } catch (error) {
      logger.log(`Error completing order: ${error.message}`, "ERROR");
      setSnackbarMessage(
        "An unexpected error occurred. Please try again later."
      );
      setSnackbarOpen(true);
    }
  };

  const toInvoiceDateKey = (idate) => {
    if (!idate) return null;
    const raw = String(idate).trim();
    if (!raw) return null;

    // Pure calendar date — keep as written (matches backend)
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

    // ISO datetime → IST calendar day
    if (/^\d{4}-\d{2}-\d{2}T/.test(raw)) {
      const d = new Date(raw);
      if (!isNaN(d.getTime())) {
        return d.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
      }
      return raw.slice(0, 10);
    }

    // dd MMM yyyy
    const mon = raw.match(/^(\d{1,2})\s+([A-Za-z]{3})\s+(\d{4})$/);
    if (mon) {
      const months = {
        jan: "01", feb: "02", mar: "03", apr: "04", may: "05", jun: "06",
        jul: "07", aug: "08", sep: "09", oct: "10", nov: "11", dec: "12",
      };
      const m = months[mon[2].toLowerCase()];
      if (m) return `${mon[3]}-${m}-${mon[1].padStart(2, "0")}`;
    }

    // dd/MM/yyyy or dd-MM-yyyy
    const dmy = raw.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
    if (dmy) {
      return `${dmy[3]}-${dmy[2].padStart(2, "0")}-${dmy[1].padStart(2, "0")}`;
    }

    const d = new Date(raw);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    }
    return null;
  };

  const parseInvoiceDate = (idate) => {
    const key = toInvoiceDateKey(idate);
    if (!key) return new Date(0);
    return new Date(`${key}T00:00:00+05:30`);
  };

  const formatInvoiceDate = (idate) => {
    const key = toInvoiceDateKey(idate);
    if (!key) return idate ? String(idate) : "N/A";
    const d = new Date(`${key}T00:00:00+05:30`);
    if (isNaN(d.getTime())) return String(idate);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "Asia/Kolkata",
    });
  };

  const getSalesmanName = (order) => {
    const name = String(order?.salesman || order?.MR_Name || "").trim();
    return name || "N/A";
  };

  // Backend already filters by IDate when start/end are set — do not re-filter
  // here or Total Orders / pagination will disagree with the visible rows.
  const displayOrders = Array.isArray(orders) ? orders : [];

  const filteredOrders1 = (() => {
    return displayOrders
      .filter((order) => {
        // Apply other filters (e.g., based on selectedOption and searchQuery)
        const option = selectedOption || "OrderNo";
        const matchesSearchQuery =
          option === "OrderNo"
            ? order.Order_No.toLowerCase().includes(searchQuery.toLowerCase())
            : option === "Driver"
              ? order.driverName.toLowerCase().includes(searchQuery.toLowerCase())
              : option === "Salesman"
                ? getSalesmanName(order).toLowerCase().includes(searchQuery.toLowerCase())
                : option === "Area"
                  ? (order.area || "")
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
                  : option === "Unassigned"
                    ? order.o_status === "0" &&
                    !order.Order_No.endsWith("*") &&
                    order.Order_No.toLowerCase().includes(searchQuery.toLowerCase())
                    : option === "Collection"
                      ? order.o_status === "0" &&
                      order.Order_No.endsWith("*") &&
                      order.Order_No.toLowerCase().includes(searchQuery.toLowerCase())
                      : option === "OnWay"
                        ? order.o_status === "5" &&
                        order.Order_No.toLowerCase().includes(searchQuery.toLowerCase())
                        : option === "Picked"
                          ? order.o_status === "4" &&
                          order.Order_No.toLowerCase().includes(searchQuery.toLowerCase())
                          : option === "CAddress"
                            ? order.Rec_Add.toLowerCase().includes(searchQuery.toLowerCase())
                            : order.Rec_Name.toLowerCase().includes(searchQuery.toLowerCase());
        return matchesSearchQuery;
      })
      .sort((a, b) => parseInvoiceDate(b.IDate) - parseInvoiceDate(a.IDate));
  })();

  const handleSelectOrder = (orderId, isChecked) => {
    if (isChecked) {
      setSelectedOrders([...selectedOrders, orderId]);
    } else {
      setSelectedOrders(selectedOrders.filter((id) => id !== orderId));
    }
  };

  const onEditDetailsClick = (orderId) => {
    const Orders = orders.find((Order) => Order._id === orderId);
    if (Orders) {
      setEditOrderDetails(Orders);
      setIsEditModalOpen(true);
    } else {
      logger.log("Order not found For Editting ", "ERROR");
    }
  };

  const handleEditInputChange = (field, value) => {
    setEditOrderDetails((prevDetails) => ({
      ...prevDetails,
      [field]: value,
    }));
  };

  const handleOpenAssignModal = () => {
    setReason("");
    setShowModal(true);
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setSelectedOrders(orders.map((order) => order._id));
    } else {
      setSelectedOrders([]);
    }
  };

  const handleAssignmentComplete = useCallback(() => {
    setSelectedOrders([]); // Reset the selected orders after assignment
  }, [setSelectedOrders]);

  const time = (delTime, delDate) => {
    const dateTimeString = `${delDate} ${delTime}`;
    const deliveryDateTime = new Date(dateTimeString);

    if (isNaN(deliveryDateTime)) {
      return false;
    }
    const currentDateTime = new Date();
    const timeDifference =
      (currentDateTime - deliveryDateTime) / (1000 * 60 * 60);
    return timeDifference > permission.hour1;
  };

  const hasExceededHour1 = (delTime, delDate) => {
    const dateTimeString = `${delDate} ${delTime}`;
    const deliveryDateTime = new Date(dateTimeString);
    if (isNaN(deliveryDateTime)) return false;
    const timeDifference = (new Date() - deliveryDateTime) / (1000 * 60 * 60);
    const threshold = permission.hour1 ?? 6;   // fallback to 6h if not set
    return timeDifference > threshold;
  };

  const hasExceededHour2 = (delTime, delDate) => {
    const dateTimeString = `${delDate} ${delTime}`;
    const deliveryDateTime = new Date(dateTimeString);
    if (isNaN(deliveryDateTime)) return false;
    const timeDifference = (new Date() - deliveryDateTime) / (1000 * 60 * 60);
    const threshold = permission.hour2 ?? 12;  // fallback to 12h if not set
    return timeDifference > threshold;
  };

  const getOrderHighlightClass = (order) => {
    if (order.o_status === "2" || order.Status === 4) return "black";
    if (hasExceededHour2(order.Del_Time, order.Del_Date)) return "red";
    if (hasExceededHour1(order.Del_Time, order.Del_Date)) return "blue";
    if (order.isUrgent) return "urgent";
    return "black";
  };

  const handleMarkUrgent = async (orderId) => {
    try {
      const response = await fetch(`/api/ordera/urgent/${orderId}/${userEmail}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Failed to mark order as urgent");
      }

      const updatedOrder = await response.json();
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order._id === updatedOrder._id ? { ...order, ...updatedOrder } : order
        )
      );
      setSnackbarMessage("Order marked as urgent");
      setSnackbarOpen(true);
    } catch (error) {
      logger.log(`Error marking order as urgent: ${error.message}`, "ERROR");
      setSnackbarMessage("Failed to mark order as urgent");
      setSnackbarOpen(true);
    }
  };

  // Function to open the label modal with selected orders
  const handleOpenLabelModal = (orderIds) => {
    // Ensure that selectedOrder is cleared
    setSelectedOrder(null);

    // Find the selected orders by their IDs and add adminEmail to each
    const selectedOrdersWithEmail = orderIds.map((orderId) => {
      const selectedOrder = orders.find((order) => order._id === orderId);
      return {
        ...selectedOrder,
        adminEmail: userEmail,
      };
    });
    setSelectedOrdersForLabel(selectedOrdersWithEmail); // Set state with selected orders
    setShowLabelModal(true); // Open the label modal
  };

  const orderStatus = selectedOrder ? selectedOrder.Status : null;

  const handleSaveEdit = async () => {
    if (!editOrderDetails) return;
    if (
      !editOrderDetails?.Rec_Name ||
      !editOrderDetails?.Rec_Add ||
      !editOrderDetails?.amount
    ) {
      setSnackbarMessage("Fields can't be empty");
      setSnackbarOpen(true);
      return;
    }
    try {
      const adminEmail = sessionStorage.getItem("adminEmail");
      const response = await fetch(`/api/ordera/update/${editOrderDetails._id}/${adminEmail}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editOrderDetails),
      }
      );
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to Edit Order: ${errorText}`);
      }
      const updatedOrder = await response.json();
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order._id === updatedOrder._id
            ? { ...order, ...updatedOrder, Driv_Email: order.Driv_Email }
            : order
        )
      );
      setIsEditModalOpen(false);
    } catch (error) {
      logger.log(`Error updating orders: ${error.message}`, "ERROR");
    }
    setSuccessSnackbarMessage("Details updated");
    setSuccessSnackbarOpen(true);
  };

  const paymentModes = [
    "Cash",
    "Cheque",
    "UPI",
    "Signed Bill Return",
    "Bill with Party",
    "Bill Left with Sales Man",
  ];

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setPhone(value);
      setError("");
    } else {
      setError("Enter a valid 10-digit number");
    }
  };

  // Validation when two-part payment is selected
  useEffect(() => {
    if (paymentType === "twoParts" && enteredAmount1 && enteredAmount2) {
      const totalAmount = Number(enteredAmount1) + Number(enteredAmount2);
      if (totalAmount !== Number(orderAmount)) {
        setWarning(
          "The sum of Amount 1 and Amount 2 does not match the total order amount"
        );
      } else {
        setWarning("");
      }
    }
  }, [enteredAmount1, enteredAmount2, paymentType, orderAmount]);

  // Validation when three-part payment is selected
  useEffect(() => {
    if (
      paymentType === "threeParts" &&
      enteredAmount1 &&
      enteredAmount2 &&
      enteredAmount2
    ) {
      const totalAmount =
        Number(enteredAmount1) +
        Number(enteredAmount2) +
        Number(enteredAmount3);
      if (totalAmount !== Number(orderAmount)) {
        setWarning(
          "The sum of Amount 1, Amount 2 and Amount 3 does not match the total order amount"
        );
      } else {
        setWarning("");
      }
    }
  }, [
    enteredAmount1,
    enteredAmount2,
    enteredAmount3,
    paymentType,
    orderAmount,
  ]);

  const handleChequeDateChange = (value, chequeType) => {
    const selectedDate = new Date(value);
    const currentDate = new Date();
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(currentDate.getMonth() - 3);

    if (selectedDate < threeMonthsAgo) {
      if (chequeType === "cheque1") {
        setChequeDateError1("Cheque date cannot be older than 3 months.");
      } else {
        setChequeDateError2("Cheque date cannot be older than 3 months.");
      }
    } else {
      if (chequeType === "cheque1") {
        setChequeDateError1("");
        setChequeDate1(value);
      } else {
        setChequeDateError2("");
        setChequeDate2(value);
      }
    }
  };

  useEffect(() => {
    const fetchBillToCollectOrders = async () => {
      try {
        const response = await fetch(`/api/ordera/billToCollect/${userEmail}`);
        const data = await response.json();
        setBillOrders(data);
      } catch (error) {
        logger.log(`Error in fetching the billtoCollectOrders : ${error.message}`, "ERROR");
      }
    };

    fetchBillToCollectOrders();
  }, []);

  return (
    <div>
      <ToastContainer />
      <Order
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />
      <div>
        <div style={{ textAlign: "center", padding: "20px" }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
              }}
            >
              <CircularProgress />
              <Typography variant="h6" style={{ marginTop: "20px" }}>
                Fetching data...
              </Typography>
            </div>
          ) : (
            <>
              {(role === "admin" ||
                (role === "dispatcher" && permission.assignBulk)) &&
                selectedOrders.length > 0 && (
                  <div className="bulk-action-bar" role="toolbar" aria-label="Bulk order actions">
                    <div className="bulk-action-count">
                      <strong>{selectedOrders.length}</strong> selected
                    </div>
                    <div className="bulk-action-btns">
                      <button
                        type="button"
                        className="bulk-action-btn is-primary"
                        onClick={handleOpenAssignModal}
                      >
                        <AddIcon fontSize="inherit" />
                        Assign
                      </button>
                      <button
                        type="button"
                        className="bulk-action-btn"
                        onClick={() => handleOpenLabelModal(selectedOrders)}
                      >
                        <DownloadIcon fontSize="inherit" />
                        Labels
                      </button>
                      <button
                        type="button"
                        className="bulk-action-btn"
                        onClick={() => handleOpenReassignModal(selectedOrders)}
                      >
                        <MdDoNotDisturb />
                        Unassign
                      </button>
                      <button
                        type="button"
                        className="bulk-action-btn is-danger"
                        onClick={() => handleOpenCancelModal(selectedOrders)}
                      >
                        <MdDelete />
                        Delete
                      </button>
                    </div>
                    <button
                      type="button"
                      className="bulk-action-clear"
                      onClick={() => {
                        setSelectedOrders([]);
                        setSelectedOrderIds([]);
                      }}
                    >
                      Clear
                    </button>
                  </div>
                )}
              <div className="TotalCu">
                Total Orders: {totalOrders}
              </div>
              <div className="stickHead">
                <table>
                  <thead>
                    <tr>
                      <th className="Cth">
                        <input
                          type="checkbox"
                          checked={
                            orders.length > 0 && selectedOrders.length === orders.length
                          }
                          onChange={(e) => handleSelectAll(e.target.checked)}
                          autocomplete="off"
                        />
                      </th>
                      <th className="Cth">
                        <strong>Order No.</strong>
                      </th>
                      <th className="Cth">
                        <strong>Company Name</strong>
                      </th>
                      <th className="Cth">
                        <strong>Company Address</strong>
                      </th>
                      <th className="Cth">
                        <strong>Amount</strong>
                      </th>
                      <th className="Cth">
                        <strong>Distance (in km)</strong>
                      </th>
                      <th className="Cth">
                        <strong>Order Placed</strong>
                      </th>
                      {/* <th className="Cth">
                        <strong>IDate</strong>
                      </th>
                      <th className="Cth">
                        <strong>Salesman</strong>
                      </th>
                      <th className="Cth">
                        <strong>Req. Pickup Time</strong>
                      </th> */}
                      <th className="Cth">
                        {/* <strong>Req. Delivery Time & Date</strong> */}
                        <strong>Req. Delivery Date</strong>
                      </th>
                      <th className="Cth">
                        <strong>Area</strong>
                      </th>
                      <th className="Cth">
                        <strong>Pickup Ready</strong>
                      </th>
                      <th className="Cth">
                        <strong>Driver</strong>
                      </th>
                      <th className="Cth">
                        <strong>Status</strong>
                      </th>
                      <th className="Cth">
                        <strong>Actions</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayOrders.length === 0 ? (
                      <tr className="less-full-width-container">
                        <td className="noOrders" colSpan="15">
                          <div className="center-content">
                            <div className="icon-wrapper">
                              <FaListUl className="icon" />
                            </div>
                            <span className="noOrdersMsg">No orders found</span>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      (Array.isArray(displayOrders) ? displayOrders : [])
                        .sort((a, b) => parseInvoiceDate(b.IDate) - parseInvoiceDate(a.IDate))
                        .map((order) => (
                          <tr
                            key={order._id}
                            className={`tdCu ${getOrderHighlightClass(order)}`}
                          >
                            <td className="tdCu">
                              <input
                                type="checkbox"
                                checked={selectedOrders.includes(order._id)}
                                onChange={(e) =>
                                  handleSelectOrder(order._id, e.target.checked)
                                }
                                autocomplete="off"
                              />
                            </td>
                            <td className="tdCu">
                              <button
                                className="detailsD"
                                onClick={() =>
                                  handleOrderDetailsClick(order._id)
                                }
                              >
                                <b>{order.Order_No}</b>
                              </button>
                            </td>
                            <td className="tdCu">{order.Rec_Name || "N/A"}</td>
                            <td className="tdCu">{order.Rec_Add || "N/A"}</td>
                            <td className="tdCu">{`₹ ${order.amount}`}</td>
                            <td className="tdCu">{order.distance || "N/A"}</td>
                            <td className="tdCu">{order.o_time || "N/A"}</td>
                            {/* <td className="tdCu" title={order.IDate || ""}>{formatInvoiceDate(order.IDate)}</td>
                            <td className="tdCu">{getSalesmanName(order)}</td>
                            <td className="tdCu">{order.Pick_Time || "N/A"}</td> */}
                            <td
                              key={order._id}
                              className={`tdCu ${getOrderHighlightClass(order)}`}
                            >
                              {order.isUrgent
                                ? `${order.Del_Date || "N/A"} ${order.Del_Time || ""}`.trim()
                                : order.Del_Date || "N/A"}
                            </td>
                            <td className="tdCu">
                              {order.area || "N/A"}
                            </td>
                            <td className="tdCu" title={
                              ["2", "3", "4", "5"].includes(String(order.o_status))
                                ? "Toggle disabled: Order already processed"
                                : ""
                            }
                              style={{
                                opacity: ["2", "3", "4", "5"].includes(String(order.o_status)) ? 0.5 : 1,
                                cursor: ["2", "3", "4", "5"].includes(String(order.o_status)) ? "not-allowed" : "pointer"
                              }}
                            >
                              <ToggleSwitch
                                disabled={["2", "3", "4", "5"].includes(String(order.o_status))}
                                checked={order.pickup_ready === "1"}
                                onChange={(e) => {
                                  if (["2", "3", "4", "5"].includes(String(order.o_status))) return;
                                  handleToggle(order._id, e.target.checked ? "1" : "0");
                                }}
                              />
                            </td>
                            <td className="tdCu">
                              {role === "admin" ||
                                (role === "dispatcher" &&
                                  permission.canAssign) ? (
                                order.o_status === "0" ||
                                  order.o_status === "3" ? (
                                  <button
                                    className="assignD"
                                    onClick={() => handleAssignClick(order._id)}
                                  >
                                    +Assign
                                  </button>
                                ) : (
                                  <span className="assigned">
                                    {
                                      order.driverName && order.driverName !== "N/A"
                                        ? order.driverName
                                        : order.Driv_Email
                                          ? (order.Driv_Email === userEmail ? userName : (role === "dispatcher" ? "Admin" : userName))
                                          : "N/A"
                                    }
                                  </span>
                                )
                              ) : (
                                <span className="assigned">
                                  {
                                    order.driverName && order.driverName !== "N/A"
                                      ? order.driverName
                                      : order.Driv_Email
                                        ? (order.Driv_Email === userEmail ? userName : (role === "dispatcher" ? "Admin" : userName))
                                        : "N/A"
                                  }
                                </span>
                              )}
                            </td>
                            <td className="tdCu">
                              {order.o_status === "0" ? (
                                !order.Order_No.endsWith("*") ? (
                                  <span className="unassigned">Unassigned</span>
                                ) : (
                                  <span className="unassigned">
                                    Bills for Collection
                                  </span>
                                )
                              ) : order.o_status === "1" ? (
                                <span className="assigned">Assigned</span>
                              ) : order.o_status === "2" ? (
                                <span className="completed">Completed</span>
                              ) : order.o_status === "3" ? (
                                <span className="completed">Incomplete</span>
                              ) : order.o_status === "4" ? (
                                <span className="on way">Picked Up</span>
                              ) : order.o_status === "5" ? (
                                <span className="on way">On the Way</span>
                              ) : (
                                "N/A"
                              )}
                            </td>
                            <td className="tdCu">
                              <button
                                className="Dbutton"
                                onClick={(e) =>
                                  handleThreeDotsClick(
                                    e,
                                    order._id,
                                    order.o_status
                                  )
                                }
                              >
                                ...
                              </button>
                            </td>
                          </tr>
                        ))
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
      <Tooltip
        id="late-tooltip"
        place="bottom"
        content="Download Excel"
        style={{
          cursor: "pointer",
          fontSize: "12px",
          padding: "5px",
          backgroundColor: "#333",
          color: "#fff",
          borderRadius: "4px",
          textAlign: "center",
        }}
      />

      {
        showDModal && (
          <DetailsModal
            showDModal={showDModal}
            onClose={() => setShowDModal(false)}
            selectedOrder={selectedOrder}
          />
        )
      }

      {
        showModal && (
          <AssignModal
            showModal={showModal}
            onClose={handleCloseModal}
            oid={selectedOrderId}
            actionType={actionType}
            onStatusUpdated={handleStatusUpdated}
            selectedOrders={selectedOrders}
            onAssignmentComplete={handleAssignmentComplete}
            reason={reason}
          />
        )
      }

      {
        openBillModal ? (
          billOrders.length > 0 ? (
            <BillModal orders={billOrders} onBillModalClose={setOpenBillModal} />
          ) : null
        ) : null
      }

      <ReasonModal
        open={showReasonModal}
        onClose={() => setShowReasonModal(false)}
        onSubmit={handleReasonSubmit}
      />

      <ActionsDropdown
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        onEditDetailsClick={onEditDetailsClick}
        onReassignClick={handleReassignClick}
        onViewDetailsClick={handleViewDetailsDropdownClick}
        onLabelClick={handleViewLabelClick}
        orderId={selectedOrderId}
        onOpenCancelModal={handleOpenCancelModal}
        onOpenUnassignModal={handleOpenReassignModal}
        onOpenCompleteModal={handleOpenCompleteModal}
        onMarkUrgent={handleMarkUrgent}
        isUrgent={
          orders.find((order) => order._id === selectedOrderId)?.isUrgent
        }
        handleCompleteOrder={handleCompleteOrder}
        role={role}
        permission={permission}
        orderStatus={statusToDisableReassignButton}
        Mop={orders.mop}
        Mop2={orders.mop2}
        Mop3={orders.mop3}
        successSnackbarOpen={successSnackbarOpen}
        handleSnackbarClose={handleSnackbarClose}
        successSnackbarMessage={successSnackbarMessage}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
      />

      <Dialog open={showCancelModal} onClose={handleCloseCancelModal}>
        <DialogTitle>{"Delete Orders"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {selectedOrderIds.length === 1
              ? "Are you sure you want to delete this order?"
              : `Are you sure you want to delete these orders?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseCancelModal}
            style={{
              backgroundColor: "#79c6e9",
              border: "1px solid #ccc",
              color: "#333",
              borderRadius: "4px",
              padding: "6px 12px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCancelOrder}
            style={{
              backgroundColor: "#79c6e9",
              border: "1px solid #79c6e9",
              color: "white",
              borderRadius: "4px",
              padding: "6px 12px",
            }}
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showUnassignModal} onClose={handleCloseUnassignModal}>
        <DialogTitle>{"Unassign Orders"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {selectedOrderIds.length === 1
              ? "Are you sure you want to unassign this order?"
              : `Are you sure you want to unassign these orders?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseUnassignModal}
            style={{
              backgroundColor: "#79c6e9",
              border: "1px solid #ccc",
              color: "#333",
              borderRadius: "4px",
              padding: "6px 12px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUnassignOrder}
            style={{
              backgroundColor: "#79c6e9",
              border: "1px solid #79c6e9",
              color: "white",
              borderRadius: "4px",
              padding: "6px 12px",
            }}
            autoFocus
          >
            Unassign
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showCompleteModal} onClose={handleClosecompleteModal}>
        <DialogTitle>Complete Order</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to complete the order?
          </DialogContentText>

          {/* Payment Type Selection */}
          <FormControl component="fieldset" margin="normal">
            <FormLabel component="legend">Payment Type</FormLabel>
            <RadioGroup
              value={paymentType}
              onChange={(e) => {
                setPaymentType(e.target.value);
                if (e.target.value === "full") {
                  setEnteredAmount1(orderAmount); // Auto-fill amount for full payment
                }
              }}
            >
              <FormControlLabel
                value="full"
                control={<Radio />}
                label="Full Payment"
              />
              <FormControlLabel
                value="twoParts"
                control={<Radio />}
                label="Two Parts Payment"
              />
              <FormControlLabel
                value="threeParts"
                control={<Radio />}
                label="Three Parts Payment"
              />
            </RadioGroup>
          </FormControl>

          {/* Primary Mode of Payment */}
          <FormControl fullWidth margin="dense">
            <InputLabel
              style={{
                paddingLeft: "5px",
                paddingRight: "5px",
                backgroundColor: "White",
              }}
            >
              Mode of Payment *
            </InputLabel>
            <Select
              value={inputMop || ""}
              onChange={(e) => setInputMop(e.target.value)}
            >
              {paymentModes
                .filter((mode) => mode !== inputMop2 && mode !== inputMop3)
                .map((mode) => (
                  <MenuItem key={mode} value={mode}>
                    {mode}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* Cheque Details for Primary MOP */}
          {inputMop === "Cheque" && (
            <>
              <TextField
                margin="dense"
                label="Cheque Number "
                fullWidth
                variant="outlined"
                value={chequeNumber1 || ""}
                onChange={(e) => setChequeNumber1(e.target.value)}
                required
              />
              <TextField
                margin="dense"
                label="Bank Name "
                fullWidth
                variant="outlined"
                value={bankName1 || ""}
                onChange={(e) => setBankName1(e.target.value)}
                required
              />
              <TextField
                margin="dense"
                label="Cheque Date "
                fullWidth
                variant="outlined"
                type="date"
                value={chequeDate1 || ""}
                onChange={(e) =>
                  handleChequeDateChange(e.target.value, "cheque1")
                }
                InputLabelProps={{ shrink: true }}
                error={chequeDateError1 !== ""}
                helperText={chequeDateError1}
                required
              />
            </>
          )}

          {/* Amount 1 */}
          <TextField
            margin="dense"
            label="Amount 1 (in ₹)"
            fullWidth
            variant="outlined"
            value={enteredAmount1 || ""}
            onChange={(e) => setEnteredAmount1(e.target.value)}
            type="number"
            required={paymentType !== ""}
            error={
              (paymentType === "full" &&
                Number(enteredAmount1) !== Number(orderAmount)) ||
              (paymentType === "twoParts" && warning) ||
              (paymentType === "threeParts" && warning)
            }
            helperText={
              paymentType === "full" &&
                Number(enteredAmount1) !== Number(orderAmount)
                ? "Amount does not match"
                : paymentType === "twoParts" && warning
                  ? "The sum of Amount 1 and Amount 2 does not match the total order amount"
                  : paymentType === "threeParts" && warning
                    ? "The sum of Amount 1, Amount 2 and Amount 3 does not match the total order amount"
                    : ""
            }
          />
          {/* Secondary Payment Fields */}
          {paymentType === "twoParts" && (
            <>
              <FormControl fullWidth margin="dense">
                <InputLabel
                  style={{
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    backgroundColor: "White",
                  }}
                >
                  Secondary Mode of Payment *{" "}
                </InputLabel>
                <Select
                  value={inputMop2 || ""}
                  onChange={(e) => setInputMop2(e.target.value)}
                >
                  {paymentModes
                    .filter((mode) => mode !== inputMop && mode !== inputMop3)
                    .map((mode) => (
                      <MenuItem key={mode} value={mode}>
                        {mode}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              {/* Cheque Details for Secondary MOP */}
              {inputMop2 === "Cheque" && (
                <>
                  <TextField
                    margin="dense"
                    label="Cheque Number "
                    fullWidth
                    variant="outlined"
                    value={chequeNumber2 || ""}
                    onChange={(e) => setChequeNumber2(e.target.value)}
                    required
                  />
                  <TextField
                    margin="dense"
                    label="Bank Name "
                    fullWidth
                    variant="outlined"
                    value={bankName2 || ""}
                    onChange={(e) => setBankName2(e.target.value)}
                    required
                  />
                  <TextField
                    margin="dense"
                    label="Cheque Date "
                    fullWidth
                    variant="outlined"
                    type="date"
                    value={chequeDate2 || ""}
                    onChange={(e) =>
                      handleChequeDateChange(e.target.value, "cheque2")
                    }
                    InputLabelProps={{ shrink: true }}
                    error={chequeDateError2 !== ""}
                    helperText={chequeDateError2}
                    required
                  />
                </>
              )}

              <TextField
                margin="dense"
                label="Amount 2 (in ₹)"
                fullWidth
                variant="outlined"
                value={enteredAmount2 || ""}
                onChange={(e) => setEnteredAmount2(e.target.value)}
                type="number"
                required={paymentType === "twoParts"}
                error={paymentType === "twoParts" && warning}
                helperText={
                  paymentType === "twoParts" && warning
                    ? "The sum of Amount 1 and Amount 2 does not match the total order amount"
                    : ""
                }
              />
            </>
          )}

          {paymentType === "threeParts" && (
            <>
              {/* Secondary MOP */}
              <FormControl fullWidth margin="dense">
                <InputLabel
                  style={{
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    backgroundColor: "White",
                  }}
                >
                  Secondary Mode of Payment *
                </InputLabel>
                <Select
                  value={inputMop2 || ""}
                  onChange={(e) => setInputMop2(e.target.value)}
                >
                  {paymentModes
                    .filter((mode) => mode !== inputMop && mode !== inputMop3)
                    .map((mode) => (
                      <MenuItem key={mode} value={mode}>
                        {mode}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              {/* Cheque Fields for MOP2 */}
              {inputMop2 === "Cheque" && (
                <>
                  <TextField
                    margin="dense"
                    label="Cheque Number"
                    fullWidth
                    variant="outlined"
                    value={chequeNumber2 || ""}
                    onChange={(e) => setChequeNumber2(e.target.value)}
                    required
                  />
                  <TextField
                    margin="dense"
                    label="Bank Name"
                    fullWidth
                    variant="outlined"
                    value={bankName2 || ""}
                    onChange={(e) => setBankName2(e.target.value)}
                    required
                  />
                  <TextField
                    margin="dense"
                    label="Cheque Date"
                    type="date"
                    fullWidth
                    variant="outlined"
                    value={chequeDate2 || ""}
                    onChange={(e) =>
                      handleChequeDateChange(e.target.value, "cheque2")
                    }
                    InputLabelProps={{ shrink: true }}
                    error={chequeDateError2 !== ""}
                    helperText={chequeDateError2}
                    required
                  />
                </>
              )}

              {/* Amount 2 */}
              <TextField
                margin="dense"
                label="Amount 2 (in ₹)"
                fullWidth
                variant="outlined"
                type="number"
                value={enteredAmount2 || ""}
                onChange={(e) => setEnteredAmount2(e.target.value)}
                required
                error={Boolean(warning)}
                helperText={
                  warning &&
                  "The sum of Amount 1, Amount 2 and Amount 3 does not match the total order amount"
                }
              />

              {/* Tertiary MOP */}
              <FormControl fullWidth margin="dense">
                <InputLabel
                  style={{
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    backgroundColor: "White",
                  }}
                >
                  Tertiary Mode of Payment *
                </InputLabel>
                <Select
                  value={inputMop3 || ""}
                  onChange={(e) => setInputMop3(e.target.value)}
                >
                  {paymentModes
                    .filter((mode) => mode !== inputMop && mode !== inputMop2)
                    .map((mode) => (
                      <MenuItem key={mode} value={mode}>
                        {mode}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              {/* Cheque Fields for MOP3 */}
              {inputMop3 === "Cheque" && (
                <>
                  <TextField
                    margin="dense"
                    label="Cheque Number"
                    fullWidth
                    variant="outlined"
                    value={chequeNumber3 || ""}
                    onChange={(e) => setChequeNumber3(e.target.value)}
                    required
                  />
                  <TextField
                    margin="dense"
                    label="Bank Name"
                    fullWidth
                    variant="outlined"
                    value={bankName3 || ""}
                    onChange={(e) => setBankName3(e.target.value)}
                    required
                  />
                  <TextField
                    margin="dense"
                    label="Cheque Date"
                    type="date"
                    fullWidth
                    variant="outlined"
                    value={chequeDate3 || ""}
                    onChange={(e) =>
                      handleChequeDateChange(e.target.value, "cheque3")
                    }
                    InputLabelProps={{ shrink: true }}
                    error={chequeDateError3 !== ""}
                    helperText={chequeDateError3}
                    required
                  />
                </>
              )}

              {/* Amount 3 */}
              <TextField
                margin="dense"
                label="Amount 3 (in ₹)"
                fullWidth
                variant="outlined"
                type="number"
                value={enteredAmount3 || ""}
                onChange={(e) => setEnteredAmount3(e.target.value)}
                required
                error={Boolean(warning)}
                helperText={
                  warning &&
                  "The sum of Amount 1, Amount 2 and Amount 3 does not match the total order amount"
                }
              />
            </>
          )}

          {/* Delivery Date */}
          <TextField
            margin="dense"
            label="Delivery Date (Actual)"
            fullWidth
            variant="outlined"
            type="date"
            value={inputDelDate}
            onChange={(e) => setInputdelDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            required
          />

          {/* Receiver Name */}
          <TextField
            margin="dense"
            label="Receiver Name"
            fullWidth
            variant="outlined"
            value={receiver || ""}
            onChange={(e) => setReceiver(e.target.value)}
            required
          />

          {/* Receiver Phone Number */}
          <TextField
            margin="dense"
            label="Receiver Number"
            fullWidth
            variant="outlined"
            type="number"
            value={phone || ""}
            onChange={handlePhoneChange}
            required
            error={Boolean(error)}
            helperText={error}
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClosecompleteModal}
            style={{
              color: "#79c6e9",
              borderColor: "#79c6e9",
              border: "1px solid",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleCompleteOrder(selectedOrderId)}
            style={{
              color:
                paymentType && inputMop && receiver && phone.length === 10
                  ? "#79c6e9"
                  : "#9e9e9e",
              borderColor:
                paymentType && inputMop && receiver && phone.length === 10
                  ? "#79c6e9"
                  : "#9e9e9e",
              border: "1px solid",
              opacity:
                paymentType && inputMop && receiver && phone.length === 10
                  ? 1
                  : 0.5,
            }}
            disabled={
              !(paymentType && inputMop && receiver && phone.length === 10)
            }
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal for showing the order label */}
      <Dialog open={showLabelModal} onClose={() => setShowLabelModal(false)}>
        <DialogTitle>{"Order Label"}</DialogTitle>
        <DialogContent>
          <OrderLabel
            orders={selectedOrdersForLabel}
            selectedOrder={selectedOrder}
            onClose={() => setShowLabelModal(false)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowLabelModal(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Modal */}
      <Dialog
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: { height: "80vh", width: "500px", overflowY: "auto" },
        }}
      >
        <DialogTitle>Edit Order</DialogTitle>
        <DialogContent>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <TextField
              label="Order Id"
              value={editOrderDetails?.Order_No || ""}
              onChange={(e) =>
                handleEditInputChange("Order Id", e.target.value)
              }
              fullWidth
              style={{ marginTop: "20px" }}
              disabled
            />
            <TextField
              label="Company Name"
              value={editOrderDetails?.Rec_Name || ""}
              onChange={(e) =>
                handleEditInputChange("Rec_Name", e.target.value)
              }
              fullWidth
              style={{ marginTop: "14px" }}
            />
            <TextField
              label="Company Address"
              value={editOrderDetails?.Rec_Add || ""}
              onChange={(e) => handleEditInputChange("Rec_Add", e.target.value)}
              fullWidth
              style={{ marginTop: "14px" }}
            />
            <TextField
              label="Amount (in ₹)"
              value={editOrderDetails?.amount || ""}
              onChange={(e) => handleEditInputChange("amount", e.target.value)}
              fullWidth
              style={{ marginTop: "14px" }}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setIsEditModalOpen(false)}
            style={{
              backgroundColor: "white",
              color: "black",
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "6px 12px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveEdit}
            style={{
              backgroundColor: " #79c6e9",
              color: "black",
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "6px 12px",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <div className="orders-pagination-wrap">
        <PaginationControls
          totalItems={totalOrders}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={(page) => fetchOrders(page)}
        />
      </div>
    </div >
  );
}

// ToggleSwitch component for the pickup ready column
const ToggleSwitch = ({ checked, onChange }) => (
  <label className="toggle-switch">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      autocomplete="off"
    />
    <span className="slider"></span>
  </label>
);

const ActionsDropdown = ({
  anchorEl,
  onClose,
  onReassignClick,
  onViewDetailsClick,
  onLabelClick,
  orderId,
  onOpenCancelModal,
  onOpenUnassignModal,
  onOpenCompleteModal,
  onMarkUrgent,
  isUrgent,
  role,
  permission,
  orderStatus,
  Mop,
  Mop2,
  Mop3,
  onEditDetailsClick,
  successSnackbarOpen,
  handleSnackbarClose,
  successSnackbarMessage,
  snackbarOpen,
  snackbarMessage,
}) => {
  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        sx={{
          "& .MuiPaper-root": {
            boxShadow: "1px 2px 2px 0px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
            borderRadius: "8px",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.02)",
              boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.2)",
            },
          },
          "& .MuiMenuItem-root": {
            transition: "background-color 0.3s ease, color 0.3s ease",
            "&:hover": {
              backgroundColor: "#f0f0f0",
              color: "#79c6e9",
            },
          },
        }}
      >
        {(role === "admin" ||
          (role === "dispatcher" && permission.reassignBill)) &&
          Number(orderStatus) !== 0 ? (
          <MenuItem
            onClick={() => {
              onReassignClick(orderId);
              onClose();
            }}
            disabled={
              Number(orderStatus) === 2 ||
              Number(orderStatus) === 4 ||
              Number(orderStatus) === 5
            }
          >
            Reassign
          </MenuItem>
        ) : null}
        <MenuItem
          onClick={() => {
            onViewDetailsClick(orderId);
            onClose();
          }}
        >
          View Details
        </MenuItem>
        <MenuItem
          onClick={() => {
            onLabelClick(orderId);
            onClose();
          }}
        >
          View Label
        </MenuItem>
        <MenuItem
          onClick={() => {
            onEditDetailsClick(orderId);
            onClose();
          }}
          disabled={Number(orderStatus) === 2}
        >
          Edit Details
        </MenuItem>
        {(role === "admin" || role === "dispatcher") &&
          !isUrgent &&
          Number(orderStatus) !== 2 &&
          Number(orderStatus) !== 4 ? (
          <MenuItem
            onClick={() => {
              onMarkUrgent(orderId);
              onClose();
            }}
          >
            Mark as Urgent
          </MenuItem>
        ) : null}
        {role !== "dispatcher" && (
          <MenuItem
            onClick={() => {
              onOpenCancelModal(orderId);
              onClose();
            }}
          >
            Delete Order
          </MenuItem>
        )}
        {role === "admin" ||
          (role === "dispatcher" && permission.completeBill) ? (
          <MenuItem
            onClick={() => {
              onOpenCompleteModal(orderId);
              onClose();
            }}
            disabled={Number(orderStatus) === 2}
          >
            Complete Order
          </MenuItem>
        ) : null}
        <MenuItem>
          <Link
            to={`/timeline/${orderId}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            View History
          </Link>
        </MenuItem>
        {(role === "admin" || role === "dispatcher") &&
          Number(orderStatus) !== 0 ? (
          <MenuItem
            onClick={() => {
              onOpenUnassignModal(orderId);
              onClose();
            }}
            disabled={
              Number(orderStatus) === 2 ||
              Number(orderStatus) === 4 ||
              Number(orderStatus) === 5
            }
          >
            Unassign
          </MenuItem>
        ) : null}
      </Menu>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="error"
          sx={{
            width: "100%",
            bgcolor: "white",
            color: "black",
            border: "2px solid red",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.4)",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={successSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{
            width: "100%",
            bgcolor: "white",
            color: "black",
            border: "2px solid green",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.4)",
          }}
        >
          {successSnackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

const BillModal = ({ orders, onBillModalClose, handleOrderClick }) => {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      {/* Modal box */}
      <div className="h-[50%] w-[45%] bg-white border border-black rounded-lg p-4 flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <p className="text-lg font-semibold">Today's Bills for Collection</p>
          <button
            onClick={() => {
              onBillModalClose(false);
            }}
            style={{ backgroundColor: "#07a6ef" }}
            className="text-white rounded hover:opacity-90 h-10 px-6 py-2 transition-opacity"
          >
            Close
          </button>
        </div>

        {/* Orders list */}
        <div className="overflow-y-auto">
          {orders && orders.length > 0 ? (
            <div>
              {/* Table header */}
              <div className="grid grid-cols-3 border-b border-gray-300 font-semibold text-gray-700 py-2">
                <p>Order No.</p>
                <p>Driver</p>
                <p>Receiver</p>
              </div>

              {orders.map((order) => (
                <div
                  key={order._id}
                  className="grid grid-cols-3 border-b py-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => handleOrderClick && handleOrderClick(order)}
                >
                  <p className="text-gray-800 font-medium">{order.Order_No}</p>
                  <p className="text-sm text-gray-600">
                    {order?.history[order?.history.length - 1].driver || "N/A"}
                  </p>
                  <p className="text-sm text-gray-600">{order?.Rec_Name}</p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500">No orders found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Current;
